import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import knightsTwoTrainersData from '../data/KnightsTwo';
import './KnightsTwo.css';

const KnightsTwoTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(knightsTwoTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('⚔️ Knights Two trainer selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/knight-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/knights-train-categories');
    };

    return (
        <div className="knights-two-trainers-container">
            <div className="knights-two-animated-background"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button knights-two-back"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="knights-two-trainers-header">
                <div className="header-content">
                    <h1>Mysterious & Complex Knights</h1>
                    <p>Train with the enigmatic warriors of legend and shadow</p>
                    <div className="category-stats">
                        <span className="stat-badge knights-two-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge knights-two-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge knights-two-badge">Category: Shadow Knights</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="knights-two-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="knight-two-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                        style={{
                            '--knight-two-primary-color': trainer.color,
                            '--knight-two-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Trainer Image */}
                        <div className="knight-two-trainer-image-section">
                            <div
                                className="knight-two-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="shadow-gleam-effect"></div>
                                <div className="experience-badge knight-two-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="knight-two-trainer-info-section">
                            <h3 className="knight-two-trainer-name">{trainer.name}</h3>
                            <h4 className="knight-two-trainer-title">{trainer.title}</h4>
                            <p className="knight-two-trainer-specialization">{trainer.specialization}</p>
                            <p className="knight-two-trainer-description">{trainer.intro}</p>

                            <div className="knight-two-trainer-details">
                                <div className="detail-item knight-two-detail">
                                    <div className="detail-icon">🗡️</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item knight-two-detail">
                                    <div className="detail-icon">🌙</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="knights-two-trainers-footer">
                <div className="knights-two-info">
                    <h3>Mysterious Knights Philosophy</h3>
                    <div className="knights-two-benefits-grid">
                        <div className="knight-two-benefit-item">
                            <div className="benefit-icon">🎭</div>
                            <div>
                                <strong>Artistic Warfare</strong>
                                <p>Combat training that channels creativity into devastating effectiveness</p>
                            </div>
                        </div>
                        <div className="knight-two-benefit-item">
                            <div className="benefit-icon">💪</div>
                            <div>
                                <strong>Maximum Strength</strong>
                                <p>Raw power conditioning for overwhelming physical dominance</p>
                            </div>
                        </div>
                        <div className="knight-two-benefit-item">
                            <div className="benefit-icon">👻</div>
                            <div>
                                <strong>Invisible Power</strong>
                                <p>Stealth conditioning that develops strength beyond normal perception</p>
                            </div>
                        </div>
                        <div className="knight-two-benefit-item">
                            <div className="benefit-icon">🏺</div>
                            <div>
                                <strong>Sacred Endurance</strong>
                                <p>Divine conditioning that bridges earthly duty and spiritual calling</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KnightsTwoTrainers;